// extracted by mini-css-extract-plugin
export var container = "_c1-0";
export var containerTopRight = "_c1-1";